import {NguiTooltipDirective} from "./tooltip-directive";
import {NguiTooltipModule} from './tooltip.module';

export { NguiTooltipDirective, NguiTooltipModule };



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/strip-loader/lib?strip[]=debug,strip[]=console.log!./src/index.ts